export const CHART_MAX_NUMBER_OF_DATAPOINTS = 7;
export const SCATTER_PLOT_MAX_NUMBER_OF_DATAPOINTS = 2;

export const SECTION_TYPE_KPI_SET = 'REPORT_EDITOR.SECTION.TYPE.KPI_SET';
export const SECTION_TYPE_VISUALS = 'REPORT_EDITOR.SECTION.TYPE.VISUALS';
